const dropdownFilterElement = (data, id = 'dropdown-filter') => {
  const dropdownFilter = document.createElement('div')
  dropdownFilter.classList.add('dropdown-filter')
  dropdownFilter.setAttribute('id', id)

  const dropdownFilterSelect = document.createElement('div')
  dropdownFilterSelect.classList.add('dropdown-filter__select', 'js-dropdown-filter-select')
  dropdownFilterSelect.innerHTML = 'Selecteer een regio of natuurgebied'

  const dropdownFilterInput = document.createElement('input')
  dropdownFilterInput.classList.add('js-dropdown-filter-result')
  dropdownFilterInput.type = 'hidden'
  dropdownFilterInput.name = 'Regio'

  const dropdownFilterDropdown = document.createElement('div')
  dropdownFilterDropdown.classList.add('js-dropdown-filter-dropdown', 'dropdown-filter__dropdown', 'dropdown-content')

  const dropdownFilterDropdownSearchInput = document.createElement('input')
  dropdownFilterDropdownSearchInput.classList.add('js-dropdown-filter-input', 'field__input')
  dropdownFilterDropdownSearchInput.type = 'text'
  dropdownFilterDropdownSearchInput.placeholder = 'Zoeken..'

  const dropdownFilterReset = document.createElement('button')
  dropdownFilterReset.classList.add('js-dropdown-filter-reset', 'link', 'hidden--palm')
  dropdownFilterReset.innerHTML = 'Uitzoomen op Noord-Brabant'

  const ul = document.createElement('ul')
  ul.classList.add('js-dropdown-filter-items', 'dropdown-filter__list')

  data.forEach((element) => {
    const regionLi = document.createElement('li')
    regionLi.dataset.value = element.regionId
    regionLi.dataset.searchstring = element.regionName

    const regionSpan = document.createElement('span')
    regionSpan.innerHTML = element.regionName

    regionLi.appendChild(regionSpan)

    ul.appendChild(regionLi)

    if (element.natureReserves.length) {
      const natureReservesHolder = document.createElement('li')
      natureReservesHolder.dataset.searchstring = element.regionName

      const natureReservesUl = document.createElement('ul')

      element.natureReserves.forEach((element) => {
        const natureReservesLi = document.createElement('li')
        natureReservesLi.dataset.value = element.id
        natureReservesLi.dataset.searchstring = element.name

        const natureReserveSpan = document.createElement('span')
        natureReserveSpan.innerHTML = element.name

        natureReservesLi.appendChild(natureReserveSpan)

        natureReservesUl.appendChild(natureReservesLi)
      })

      natureReservesHolder.appendChild(natureReservesUl)
      ul.appendChild(natureReservesHolder)
    }
  })

  dropdownFilterDropdown.appendChild(dropdownFilterDropdownSearchInput)
  dropdownFilterDropdown.appendChild(dropdownFilterReset)
  dropdownFilterDropdown.appendChild(ul)

  dropdownFilter.appendChild(dropdownFilterSelect)
  dropdownFilter.appendChild(dropdownFilterInput)
  dropdownFilter.appendChild(dropdownFilterDropdown)

  return dropdownFilter
}

export default dropdownFilterElement
